import { InjectionToken } from '@angular/core';

import { ISnLayoutConfig } from '../interfaces';

export const SN_LAYOUT_CONFIG = new InjectionToken<ISnLayoutConfig>('SN_LAYOUT_CONFIG');
